import { ChangeLanguageDialogContainer } from './ChangeLanguageDialogContainer.tsx';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
export const showChangeLanguageDialog = mountDialogUIReactComponent(ChangeLanguageDialogContainer);
